import React from 'react';
// import styles from './Contact.scss';
import styles from './ValuationWidget.scss';
import Input from './Input';
import { i18n, IValuationData } from './ValuationWidget';
import RadioGroup from '../MaterialUi/RadioGroup';
import Checkbox from '../MaterialUi/Checkbox';
import { IAffiliateDetails } from '../../utils/Affiliate';

export interface IContactProps {
    data: Partial<IValuationData>;
    onChange: (name: keyof IValuationData, value: string | boolean) => void;
    affiliateBank?: IAffiliateDetails;
    // className?: string;
}



const Contact: React.FC<React.PropsWithChildren<IContactProps>> = ({ onChange, data, affiliateBank }) => {
    const onValChange = (ev: React.FormEvent) => {
        const target = ev.target as HTMLInputElement;
        onChange(target.name as keyof IValuationData, target.value);
    };

    const dataProcessingAccepted = data.dataProcessingAccepted;

    const withEstateAgent = data.reason === 'sell' && (data.estateAgent === 'yes' || data.estateAgent === 'maybe' || data.estateAgentNo === 'yes');

    return (
        <div className={styles.contact}>
            <div className={styles.input + ' ' + styles.salutation}>
                <RadioGroup
                    row
                    value={data.salutation}
                    onChange={onValChange}
                    options={[
                        { label: 'Frau', value: 'Frau' },
                        { label: 'Herr', value: 'Herr' },
                        { label: '*', value: '' },
                    ]}
                />
            </div>

            <Input label="Vorname" name="firstName" value={data.firstName} onChange={onChange} required />
            <Input label="Nachname" name="lastName" value={data.lastName} onChange={onChange} required />
            <Input label="E-Mail" type="email" name="email" value={data.email} onChange={onChange} required />
            <Input label="Telefonnummer" name="phoneNumber" value={data.phoneNumber} onChange={onChange} required />

            {withEstateAgent && (
                <div className={styles.estateAgent}>
                    <Checkbox
                        value={dataProcessingAccepted}
                        // value="acceptTerms"
                        name="dataProcessingAccepted"
                        label={
                            affiliateBank?.display_name ? <>
                                Ich wünsche eine Kontaktaufnahme zu dieser Immobilie von der in meinem Profil hinterlegten Hausbank
                                bzw. ihres Maklers für eine unverbindliche Auskunft bzw. Beratung zum Verkauf der Immobilie über einen Makler.
                            </> : <>
                                Ich wünsche eine Kontaktaufnahme zu dieser Immobilie von einem der <a href="/info/servicepartner" target="_blank">hier</a> genannten
                                Wohnglück-Partner für eine unverbindliche Auskunft bzw. Beratung zum Verkauf der Immobilie über einen Makler.
                            </>
                        }
                        onChange={() => {
                            onChange('dataProcessingAccepted', !dataProcessingAccepted);
                        }}
                        // checked={dataProcessingAccepted}
                        required
                    />
                </div>
            )}
        </div>
    );
};

export default Contact;
